var React = require('react');

function AngleTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 12.998c0-.225.076-.45.232-.636L7.997 5.5l5.771 6.871a.988.988 0 0 1-.127 1.398 1.005 1.005 0 0 1-1.409-.126L7.997 8.6l-4.229 5.035c-.354.42-.984.477-1.409.126A.991.991 0 0 1 2 12.998zM14 3a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1z"}));
}

AngleTop.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleTop;

AngleTop.default = AngleTop;
